import { render } from "./TwoColumns.vue?vue&type=template&id=8a933b5a&scoped=true"
const script = {}

import "./TwoColumns.vue?vue&type=style&index=0&id=8a933b5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a933b5a"]])

export default __exports__